import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Checkbox, Form, Dropdown, Select } from "semantic-ui-react";
import PropTypes from "prop-types";

import { ProfileEdit } from "../profile/edit";
import { EditEntity } from "../../components/common/edit-entity";
import {
  clearError,
  createEstateCustomer,
} from "../../redux/modules/estate-customers";
import {
  FormdataManager,
  getInitialState,
} from "../../components/common/formdata";
import { ErrorWrap } from "../../helpers/error";
import { t } from "../../constant/translations";

function getCustomerDisplayable(customer) {
  const data = [];
  if (customer.name) {
    data.push(customer.name);
  }
  if (customer.email) {
    data.push(customer.email);
  }
  return data.join(" - ");
}

export const AddCustomerModalComponent = ({ estate }) => {
  const [formData, setFormData] = useState(null);

  const profiles = useSelector((state) => state.profile.entities);
  const lastModifiedProfile = useSelector(
    (state) => state.profile.lastModified
  );
  const estateCustomers = useSelector(
    (state) => state.estatecustomers.entities
  );
  const loading = useSelector((state) => state.estatecustomers.pending);
  const error = useSelector((state) =>
    ErrorWrap.fromError(state.estatecustomers.error)
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (lastModifiedProfile) {
      const updatedFormData = formData || { estate: estate.id };
      updatedFormData.customer = lastModifiedProfile.id;
      setFormData(updatedFormData);
    }
  }, [lastModifiedProfile]);

  const handleCreate = (data) => dispatch(createEstateCustomer(data));
  const handleClearError = () => dispatch(clearError());

  const initialState = getInitialState({
    estate: estate.id,
  });
  const manager = new FormdataManager(
    formData || initialState,
    setFormData,
    initialState
  );

  const selectCustomerOptions = profiles
    .filter(
      (p) =>
        !estateCustomers.find(
          (c) => c.estate === estate.id && c.customer === p.id
        )
    )
    .map((p) => ({
      key: p.id,
      text: getCustomerDisplayable(p),
      value: p.id,
    }));

  return (
    <EditEntity
      manager={manager}
      estate={estate}
      loading={loading}
      error={error}
      create={handleCreate}
      clearError={handleClearError}
      header={t("estate.add_inhabitat")}
      trigger_props={{
        floated: "right",
        color: "green",
        icon: "plus",
        content: t("estate.inhabitat"),
        basic: true,
      }}
    >
      <Form.Field>
        <label>{t("estate.inhabitat")}</label>
        <Dropdown
          placeholder={t("estate.choose_profile")}
          search
          selection
          options={selectCustomerOptions}
          {...manager.getAttributes("customer")}
        />
        {error.has("customer") && <span>{error.get("customer")}</span>}
      </Form.Field>
      <ProfileEdit
        block={estate.block.id}
        customTrigger_props={{
          color: "blue",
          icon: "plus",
          content: t("estate.profile"),
          basic: true,
        }}
      />
      <Form.Field>
        <label>{t("labels.type")}</label>
        <Select
          placeholder={t("estate.select_type")}
          options={[
            { key: "tenant", value: "tenant", text: t("estate.tenant") },
            { key: "owner", value: "owner", text: t("estate.owner") },
          ]}
          {...manager.getAttributes("type")}
        />
      </Form.Field>
    </EditEntity>
  );
};

AddCustomerModalComponent.propTypes = {
  estate: PropTypes.object.isRequired,
};

export const AddCustomerModal = AddCustomerModalComponent;
